import { isMobile } from '../utils/useragent';

class SeeAllProducts {
  public items: HTMLCollection;
  public closeButtons: HTMLCollection;
  public lightboxes: HTMLCollection;
  public mobileSlider: HTMLCollection;

  bindings() {
    if (this.items) {
      Object.values(this.items).forEach((item,index) => {
        item.addEventListener('click', (e: any) => {
          //e.target.nextElementSibling.classList.toggle('o-inspiration-lightbox--is-active');
          if(!isMobile()) {
            if(this.lightboxes) {
              this.lightboxes[index].classList.toggle('o-inspiration-lightbox--is-active');
            }
            // console.log('index',index, item, this.lightboxes[index]);
            document.body.classList.add('o-inspiration-lightbox--content-visible');
          }

          this.mobileSlider[index].classList.toggle('is-active');

          e.preventDefault();
          return false;
        });
      });
    }
    if (this.closeButtons) {
      Object.values(this.closeButtons).forEach((item) => {
        item.addEventListener('click', (e: any) => {
          e.target.closest('.o-inspiration-lightbox').classList.toggle('o-inspiration-lightbox--is-active');
          document.body.classList.remove('o-inspiration-lightbox--content-visible');
          e.preventDefault();
          return false;
        });
      });
    }
  }

  cache() {
    this.items = document.getElementsByClassName('js-see-all-products');
    this.lightboxes = document.getElementsByClassName('js-o-inspiration-lightbox');
    this.mobileSlider = document.getElementsByClassName('js-o-inspiration-mobile-slider');
    this.closeButtons = document.getElementsByClassName('o-inspiration-lightbox__toggler');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default SeeAllProducts;
